import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CurrencyField,
  DataTable,
  DateTimeField,
  Field,
} from '../../../commons/DataTable';

function SignalsTable({ data, total, offset, limit, onFilter }) {
  const [t] = useTranslation('SIGNALS');

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
    >
      <Field
        title="Segnalatore"
        source="signalman.businessName"
        className="text-left"
      />
      <Field
        title="Segnalatore P.iva/Codice Fiscale"
        source="signalman.taxCode"
        className="text-left"
      />
      <Field
        title="Nome Condominio"
        source="condoInfo.name"
        className="text-left"
      />
      <Field
        title="P.iva Condominio"
        source="condoInfo.vatCode"
        className="text-left"
      />
      <CurrencyField
        title="Totale fattura"
        source="estimate"
        className="txt-table-right"
      />
      <DateTimeField
        title="Data rendicontazione"
        source="accountabilityDate"
        className="text-left"
        format="DD/MM/YYYY"
      />
      <CurrencyField
        title="Totale da fatturare"
        source="shareToInvoice"
        className="txt-table-right"
      />
      <Field
        title="Numero fattura"
        source="pinvInvoice[0].invoicePinv.number"
        className="text-left"
      />
      <Field
        title="Note"
        source="notes"
        className="text-left"
        style={{
          minWidth: '200px',
          maxWidth: '300px',
          whiteSpace: 'normal',
          overflowWrap: 'break-word',
        }}
      />
    </DataTable>
  );
}
export default SignalsTable;
